import classnames from 'classnames/bind'

// Components
import Image from '@/components/common/Image'
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)
interface ProductContentProps {
  productInfo: any
}

const ProductContent = ({ productInfo }: ProductContentProps) => {
  return (
    <div className={cx('product-content-heading')}>
      <div className={cx('product-content-heading-image')}>
        <div className={cx('product-content-heading-image-logo')}>
          <Image src={'/images/share-logo.png'} alt={'heading-image'} fill style={{ objectFit: 'contain' }} />
        </div>
        <div className={cx('product-content-heading-image-product')}>
          <Image
            src={productInfo.images ? productInfo.images[0] : ''}
            alt={'heading-image'}
            fill
            style={{ objectFit: 'cover', objectPosition: 'bottom' }}
          />
        </div>
      </div>
      <div className={cx('product-content-heading-title')}>
        <p className={cx('product-content-heading-title-text')}>{productInfo.productName}</p>
        <div className={cx('product-content-heading-title-icon')}>
          <Icon.ArrowRight />
        </div>
      </div>
    </div>
  )
}
export default ProductContent
